import ProjectTemplate from "../../components/common/ProjectTemplate"
import TagBoxContainer from "../../components/conveyor/TagBoxContainer";
// import ConveyorEditor from "../../components/conveyor/ConveyorEditor";
import ConveyorEditorContainer from "../../components/conveyor/ConveyorEditorContainer";
import ConveyorWriteActionButtonsContainer from "../../components/conveyor/ConveyorWriteActionButtonsContainer";

const ConveyorWritePage = () => {

    return (
        <ProjectTemplate>
            <ConveyorEditorContainer />
            <TagBoxContainer />
            <ConveyorWriteActionButtonsContainer />
        </ProjectTemplate>
    );
};

export default ConveyorWritePage;